import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Messages } from '@app/constants/constant';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import {MessageService } from 'primeng/api';
import { SaveTechnologyTemplateService } from '@app/services/save-technology-templates.service';
import * as $ from 'jquery';
import { CustomEvaluationSkills } from '@app/model/CustomEvaluationSkills';
import { EvaluationSkills } from '@app/model/EvaluationSkills';

@Component({
  selector: 'app-add-template',
  templateUrl: './add-template.component.html',
  styleUrls: ['./add-template.component.css']
})
export class AddTemplateComponent implements OnInit {
  evaluationData : any = {};
  @Input() isNew :boolean;
  @Input() techId:string;
  @Input() oldTechId:string;
  @Input() isPreview:boolean;
  @Output() disableButtonEvent = new EventEmitter<boolean>();
  @Output() editFlagEvent = new EventEmitter<boolean>();
  _saveCandidateEvaluationFeedbackService: any;
  disableSwitchFeature: boolean;
  comeFromViewInterviewScheduledInterviewList: any;
  _router: any;
  constructor(
    private confirmationService: ConfirmationService,
    private _saveTechnologyTemplate: SaveTechnologyTemplateService,
    private spinner: NgxSpinnerService,
    private _toastService: MessageService,
    private http: HttpClient,
    private _route : Router) {
}

  ngOnInit() {
    if(this.isPreview){
      this.getApiCall(this.techId);
    }
    else if(this.isNew == false){
      this.getApiCall(this.oldTechId);
    }
    else{
      this.evaluationData.evaluationCategories = [];
    }
  }

  showHideForm(event) {
    let currentTarget = event.target;
    if (currentTarget.tagName === "SPAN") {
      currentTarget = currentTarget.parentElement;
    }
    let dataTarget = currentTarget.getAttribute("id");
    $(dataTarget).slideToggle();
    $(currentTarget).find(".fa").toggleClass("fa-chevron-down").toggleClass("fa-chevron-right");
  }
  addNewSkill(event,categoryName) {
    this.spinner.show();
    this.evaluationData.evaluationCategories.forEach(element => {
      if(categoryName==element.name){
        if (element.evaluationSkills === undefined) {
          element.evaluationSkills = [];
        }

        element.evaluationSkills.push(
          {
            groups: '',
            skills: '',
            rating: null,
            feedback: '',
            newlyAdded: true,
            customEvaluationSkills: []
          }
        )
        element.evaluationSkills[0].customEvaluationSkills.push({
          skill:''}
        )
      }
    })
    setTimeout(() => {
      this.spinner.hide();
    }, 400);

  }

  addNewSection(event)
  {
    this.spinner.show();
    this.evaluationData.evaluationCategories.push(
      {
        customEvaluationSkills: [],
        description: '',
        evaluationSkills: [],
        evaluation_category_id: '',
        name: ''
      }
    )  
  
    setTimeout(() => {
      this.spinner.hide();
    }, 400);
  }

  addCustomSkill($event,group, categoryName){
    this.spinner.show();
    this.evaluationData.evaluationCategories.forEach(element => {
      if(categoryName==element.name){
        element.evaluationSkills.forEach(item => {
        if (item.groups === group) {
          item.customEvaluationSkills.push(
          {
            skill:[]
          });
        }
        })
      }
    });
    setTimeout(() => {
      this.spinner.hide();
    }, 400);
  }

  removeSkill(event,categoryName) {
    $(event.target).removeClass('pi pi-times').addClass('pi pi-spin pi-spinner');
    let index = Number(event.target.getAttribute("id"));
    setTimeout(() => {
      this.evaluationData.evaluationCategories.forEach(element => {
        if(categoryName==element.name){
          element.evaluationSkills.splice(index, 1);
        }
      })
    }, 400);
  }

  removeCustomSkill(event, groups, categoryName){
    $(event.target).removeClass('fa fa-minus').addClass('pi pi-spin pi-spinner');
    //let index = Number(event.target.getAttribute("id"));
    setTimeout(() => {
      this.evaluationData.evaluationCategories.forEach(element => {
        if(categoryName==element.name){
          element.evaluationSkills.forEach(item => {
          if (item.groups === groups) {
            item.customEvaluationSkills.pop();
          }
          })
      }});
    }, 400);
    $(event.target).removeClass('pi pi-spin pi-spinner').addClass('fa fa-minus');
  }

  removeSection(event,categoryName) {
    $(event.target).removeClass('pi pi-times').addClass('pi pi-spin pi-spinner');
    let index = Number(event.target.getAttribute("id"));
    setTimeout(() => {
      this.evaluationData.evaluationCategories.forEach(element => {
        if(categoryName==element.name || element.name == undefined){
          this.evaluationData.evaluationCategories.splice(index, 1);
        }
      })
    }, 400);
  }


  getApiCall(technologyId){
  this.http.get(environment.apiUrl+Messages.endpoint.candidate_evaluation_feedback+technologyId).toPromise().then(res=>{
      this.evaluationData = res;
      this.editFlagEvent.emit(this.evaluationData.editTemplate);
      this.setCustomEvaluationSKills();

  });
  }

  setCustomEvaluationSKills()
  {
    
    let skill:any;
    let skills:any =[];
    this.evaluationData.evaluationCategories.forEach(element => {
      element.evaluationSkills.forEach(item => {
        skill= item.skills.replace("<ul><li>", "").replace("</li></ul>", "");  
        skills = skill.split('</li><li>');
        let data :any =[];
        skills.forEach(skillItem =>{
          data.push({skill:skillItem});
          });
        item.customEvaluationSkills = data;
      });
  })
}

getModifiedSKills()
{
  let customSkill:any;
    this.evaluationData.evaluationCategories.forEach(element => {
      element.evaluationSkills.forEach(item => { 
        var len= item.customEvaluationSkills.length;
        if(len > 1){
          let i =0;
          item.customEvaluationSkills.forEach(cSkill => { 
            if(i == len-1)
            {
              customSkill = customSkill + cSkill.skill + "</li></ul>"
            }
            else if(i ==0){
              customSkill = "<ul><li>" + cSkill.skill + "</li><li>";
            }
            else{
              customSkill = customSkill + cSkill.skill + "</li><li>"
            }
            i++;
          })
          item.skills = customSkill;
        }
        else{
          item.skills = len == 1? item.customEvaluationSkills[0].skill:"";
        }
      });
  })
}

  redirectToPreviousPage()
  {
    this._route.navigate(['./technology-add-edit']);
  }

  addBulletText(event, content) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
      content += '• '
    }

    if (content.substr(content.length - 1) == '\n') {
      content = content.substring(0, content.length - 1);
    }
    return content;
  }

  mytextOnFocus(content) {
    content += '• ';
    return content;

  }




  saveTemplate(){
    let isRequestValid:boolean = true;
    if(this.evaluationData == undefined || this.evaluationData.evaluationCategories == undefined ||this.evaluationData.evaluationCategories.length === 0)
    {
      isRequestValid = false;
      this._toastService.add({ severity: 'error', summary:'Add atleast one section.', detail: '' });
      return;
    }
    else{
      this.evaluationData.evaluationCategories.forEach(element => {
        if(element.name =="")
        {
          isRequestValid = false;
          this._toastService.add({ severity: 'error', summary:'Please add section name.', detail: '' });
        }
        else{
          let len = element.evaluationSkills.length;
          if(len == 0){
            isRequestValid = false;
            this._toastService.add({ severity: 'error', summary:'Add atleast one group for ' + element.name + ' section.', detail: '' });
          }
          else{
            element.evaluationSkills.forEach(item => {
              if(item.groups == ""){
                isRequestValid = false;
                this._toastService.add({ severity: 'error', summary:'Add group name for ' + element.name + ' section.', detail: '' });
              }
              else
                if(item.customEvaluationSkills.length == 0){
                  isRequestValid = false;
                  this._toastService.add({ severity: 'error', summary:'Add skill details for '+ item.groups + ' group and ' + element.name + ' section.', detail: '' });
                } 
                else{
                  item.customEvaluationSkills.forEach(skill => {
                    if(skill.skill =="")
                      {
                        isRequestValid = false;
                        this._toastService.add({ severity: 'error', summary:'Add skill details for ' + item.groups + ' group and ' + element.name + ' section.', detail: '' });
                      }
                    
                  });
                } 
            });
          }
        }
      });
    }

    if(!isRequestValid)
    {
      return;
    }

    this.evaluationData.technologyId = this.techId;  
    this.getModifiedSKills();
    // Submit
    this.confirmationService.confirm({
      header: "Confirmation",
      message: 'Do you want to proceed with the submission?',
      accept: () => {
        this.spinner.show();
        this.evaluationData.loggedInUser = JSON.parse(localStorage.getItem("currentUser")).user.id;
        this._saveTechnologyTemplate.create(this.evaluationData, 'interview/save-evaluation-feedback').subscribe(
          (res:any) => {
            let message = this.isNew != undefined ? Messages.sumbit_template : Messages.edit_template ;
           this._toastService.add({ severity: 'success', summary: message, detail: '' });
             //on successful save 
            this.evaluationData.isSubmitted = 1;
            this.disableButtonEvent.emit(true); 
            this._route.navigate(['./technology-add-edit']); 

          },
          (err) => {
            this.spinner.hide();
            this.evaluationData.isSubmitted = 0;
            console.log(err)
            alert(err);
          });
          this.spinner.hide();
      },
      reject: () => {
      }

    });
    
  }

}
